import React, { Component } from 'react';

import { HashLink as Link } from 'react-router-hash-link';

import { name } from 'settings';
import { BackImage, StoreButtons } from 'C4';

import logo from 'assets/images/logo/logo_white.png';

// eslint-disable-next-line react/prefer-stateless-function
export default class WelcomeView extends Component {
  render() {
    const registerSuccessful = localStorage.getItem('registerSuccessful');

    return (
      <div className="welcomeView">
        <BackImage id="760" darken />
        <div className="welcomeView__Wrapper">
          <div className="logoWelcome">
            <img src={logo} alt={name} />
          </div>
          <div className="welcomeView__Wrapper__Text">
            <h1>
              Thanks for your interest in XpoPRO virtual events.
              <br />
              This show has now ended{' '}
            </h1>
            <p className="sub" />
            <img
              className="qr"
              src="https://front.travpromobile.com/760/qr.png"
              alt="qr code"
            />
            <p>
              You can find a calendar of upcoming events as well as current
              on-demand shows in TravPRO Mobile’s new super app, TheSOURCE.
              Download it for free now.
            </p>
            <p className="app" />
            <hr />
            <StoreButtons />
            {!registerSuccessful && (
              <Link to="/login/register">
                <button>Or Sign Up for the waitlist &gt;</button>
              </Link>
            )}
            {registerSuccessful && (
              <button>
                You have been successfully registered! You will receive more
                information when the app is live!
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
